import _ from "lodash";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import nl2br from "react-nl2br";
import ReactHtmlParser from "react-html-parser";
import TelegramApp from "@twa-dev/sdk";
import TelegramButton from "components/standart/mediaButtons";

import { setNavi } from "actions";
import { LoadingIcon, LogoImage, SmartImage } from "components/standart";
import { fileUrl, userApi, frontendApi } from "reducers/api";
import Col3Container from "components/standart/col3Container";
import { Modal, ModalBody, ModalHeader, Alert } from "reactstrap";

const { api } = frontendApi.actions;
const { session, api: userApiMethods } = userApi.actions;

const Index = (props) => {
  const { sessionStore, env } = props;
  const { landings = {}, settings = {} } = env;

  const landingData = { ...landings.miniapp };

  const [categories, setCategories] = useState({ data: [], region: [], defined: false });
  const [isLoading, setLoading] = useState(false);

  const [dataSaving, setDataSaving] = useState(false);
  const [dataSaved, setDataSaved] = useState(false);

  const [userCategories, setUserCategories] = useState({ region: [], data: [] });
  const [modalOpened, setModalOpened] = useState(false);
  const toggleModal = useCallback(() => setModalOpened(!modalOpened), [modalOpened]);

  useEffect(() => {
    setDataSaved(false);
  }, [userCategories]);

  useEffect(() => {
    props.getCategories(
      {},
      {
        onSuccess(data) {
          setLoading(false);
          setCategories({
            data: _.filter(data, (value) => !value.isRegion),
            region: _.filter(data, (value) => value.isRegion),
            defined: true,
          });
          // setRegionCategories({ data: _.filter(data, (value) => value.isRegion), defined: true });
        },
        onRequest() {
          setLoading(true);
        },
      },
    );
  }, []);

  function defineCategoriesIntersection(source = [], defined = []) {
    const result = [];
    _.map(defined, (category) => {
      if (source.includes(category._id)) {
        result.push(category._id);
      }
    });
    return result;
  }

  // зафиксируем данные о том, что у нас есть пользовательские предпочтения в категориях
  useEffect(() => {
    if (categories.defined) {
      //
      setUserCategories({
        data: defineCategoriesIntersection(sessionStore.specialsCategoriesId, categories.data),
        region: defineCategoriesIntersection(sessionStore.specialsCategoriesId, categories.region),
      });
    }
  }, [categories, sessionStore.specialsCategoriesId]);

  const changeRegionCategory = useCallback(
    (categoryId) => {
      if (userCategories.region.includes(categoryId)) {
        setUserCategories({ ...userCategories, region: [] });
      } else {
        setUserCategories({ ...userCategories, region: [categoryId] });
      }
    },
    [userCategories],
  );

  const saveCategories = useCallback(() => {
    props.saveCategories(
      { body: { specialsCategoriesId: [...userCategories.data, ...userCategories.region] } },
      {
        onSuccess() {
          //
          setDataSaving(false);
          setDataSaved(true);
          try {
            TelegramApp.close();
          } catch (e) {}
          try {
            window.WebApp.close();
          } catch (e) {}
        },
        onRequest() {
          //
          setDataSaving(true);
        },
        onFailure() {
          setDataSaving(false);
        },
      },
    );
  }, [userCategories]);

  return sessionStore.account ? (
    <section className="p-0 m-0 bg-grey">
      <div className="container">
        <Col3Container>
          <div className="text-center my-auto pt-0">
            <LogoImage style={{ width: "100px", height: "100px", margin: "1.2em" }} />
          </div>

          <div className="text-center">
            <div className="large-header mb-1">{nl2br(landingData.intro?.title)}</div>
            <div className="standart-header">
              {landingData.extra?.isHtml
                ? ReactHtmlParser(landingData.intro?.content)
                : nl2br(landingData.intro?.content)}
            </div>
          </div>
          <div className="p-2"></div>
          {isLoading ? (
            <div className="text-center">
              <LoadingIcon />
            </div>
          ) : (
            <div>
              <div className="rounded-xl bg-white">
                {categories.data.length && (
                  <div>
                    {categories.data.map((category, index) => {
                      const checked = userCategories.data.includes(category._id);
                      const last = index === _.size(categories.data) - 1;
                      return (
                        <Fragment key={category._id}>
                          <div className={`row px-2 py-2 my-1 ${last ? "" : ""}`}>
                            <div className="col-2 pr-1 pt-1">
                              {category.imageFileId ? (
                                <>
                                  <SmartImage
                                    src={fileUrl(category.imageFileId, "image.jpg")}
                                    className="rounded-xl border border-1 w-100 h-auto"
                                  />
                                </>
                              ) : null}
                            </div>
                            <div className="col">
                              <div className="standart-header text-black">
                                <b>{category.name}</b>
                              </div>
                              <div className="standart-header">{category.description}</div>
                            </div>
                            <div className="col-3 text-right my-auto" style={{ fontSize: "28px" }}>
                              <div className="pretty p-switch p-toggle p-fill">
                                <input
                                  type="checkbox"
                                  checked={checked}
                                  onChange={() => {
                                    setUserCategories({
                                      ...userCategories,
                                      data: checked
                                        ? userCategories.data.filter(
                                            (categoryId) => categoryId !== category._id,
                                          )
                                        : userCategories.data.concat([category._id]),
                                    });
                                  }}
                                />
                                <div className={`state ${checked ? "p-success" : "p-secondary"}`}>
                                  <label></label>
                                </div>
                              </div>
                            </div>
                          </div>
                          {last ? null : (
                            <div className="row px-2 py-0 m-0">
                              <div className="col-2" />
                              <div className="col pl-1 pr-0">
                                <hr className="m-0 p-0 w-100" />
                              </div>
                            </div>
                          )}
                        </Fragment>
                      );
                    })}
                  </div>
                )}
              </div>

              {categories.region.length && (
                <div className="rounded-xl bg-white mt-3">
                  <div className={`row px-2 py-2 my-1`}>
                    <div className="col my-auto">
                      <div className="standart-header text-black">
                        <b>{"Городские новости"}</b>
                      </div>
                      <div className="standart-header">{nl2br(settings.regionSubtitle)}</div>
                    </div>
                    <div className="col-3 text-right my-auto" style={{ fontSize: "28px" }}>
                      <div className="pretty p-switch p-toggle p-fill">
                        <input
                          type="checkbox"
                          checked={userCategories.region.length}
                          onChange={() => {
                            // если кнопка не была включена, то показываем модалку
                            // или убираем состав региональных катерий
                            !userCategories.region.length
                              ? toggleModal()
                              : setUserCategories({ ...userCategories, region: [] });
                          }}
                        />
                        <div
                          className={`state ${
                            userCategories.region.length ? "p-success" : "p-secondary"
                          }`}
                        >
                          <label></label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {!userCategories.region.length ? null : (
                    <div className="row px-2 py-0 m-0">
                      <div className="col-2" />
                      <div className="col pl-1 pr-0">
                        <hr className="m-0 p-0 w-100" />
                      </div>
                    </div>
                  )}

                  {categories.region
                    .filter((category) => userCategories.region.includes(category._id))
                    .map((category) => {
                      return (
                        <Fragment key={category._id}>
                          <div className={`row px-2 py-2 my-1`} onClick={toggleModal}>
                            <div className="col-2 pr-1 pt-1">
                              {category.imageFileId ? (
                                <>
                                  <SmartImage
                                    src={fileUrl(category.imageFileId, "image.jpg")}
                                    className="rounded-xl border border-1 w-100 h-auto"
                                  />
                                </>
                              ) : null}
                            </div>
                            <div className="col">
                              <div className="standart-header text-black">
                                <b>{"Ваш город"}</b>
                              </div>
                              <div className="standart-header">{category.name}</div>
                            </div>
                            <div className="col-3 text-right standart-header my-auto">
                              <i className="fas fa-chevron-right" />
                            </div>
                          </div>
                        </Fragment>
                      );
                    })}

                  <Modal
                    centered
                    isOpen={modalOpened}
                    wrapClassName="fullscreen-modal bg-grey"
                    size="md"
                    toggle={toggleModal}
                  >
                    <ModalBody className="bg-grey">
                      <div className="rounded-xl bg-white">
                        {categories.region.map((category, index) => {
                          const checked = userCategories.region.includes(category._id);

                          const last = index === _.size(categories.region) - 1;
                          return (
                            <Fragment key={category._id}>
                              <div
                                className={`row px-2 py-2 my-1 ${last ? "" : ""}`}
                                onClick={() => changeRegionCategory(category._id)}
                              >
                                <div className="col-2 pr-1 pt-1">
                                  {category.imageFileId ? (
                                    <>
                                      <SmartImage
                                        src={fileUrl(category.imageFileId, "image.jpg")}
                                        className="rounded-xl border border-1 w-100 h-auto"
                                      />
                                    </>
                                  ) : null}
                                </div>
                                <div className="col">
                                  <div className="standart-header text-black">
                                    <b>{category.name}</b>
                                  </div>
                                  <div className="standart-header">{category.description}</div>
                                </div>
                                <div className="col-3 text-right my-auto">
                                  {checked ? <i className="fas fa-check" /> : null}
                                </div>
                              </div>
                              {last ? null : (
                                <div className="row px-2 py-0 m-0">
                                  <div className="col-2" />
                                  <div className="col pl-1 pr-0">
                                    <hr className="m-0 p-0 w-100" />
                                  </div>
                                </div>
                              )}
                            </Fragment>
                          );
                        })}
                      </div>
                      <div className="p-2" />

                      <div className="standart-header content-html text-center">
                        {ReactHtmlParser(settings.regionNotFound)}
                      </div>

                      <div className="p-2" />
                      <button
                        className="btn btn-primary p-3 rounded-xl w-100"
                        onClick={toggleModal}
                      >
                        <span className="standart-header text-white">{"Сохранить"}</span>
                      </button>
                    </ModalBody>
                  </Modal>
                </div>
              )}

              <div className="p-2" />

              <button className="btn btn-primary p-3 rounded-xl w-100" onClick={saveCategories}>
                <span className="standart-header  text-white">
                  {dataSaving ? <LoadingIcon /> : "Готово"}
                </span>
              </button>
            </div>
          )}
          <div className="p-3" />
        </Col3Container>
      </div>
    </section>
  ) : (
    <Col3Container>
      <div className="text-center p-5">
        <TelegramButton
          button={"Откройте приложение в Telegram"}
          url={`${settings.telegramWebApp}`}
          className="btn-xl"
        />
      </div>
    </Col3Container>
  );
};

const mapeStateToProps = (state) => ({
  sessionStore: state.user.session,
  env: state.frontend.env,
});

export default connect(mapeStateToProps, {
  setNavi,
  getCategories: api.get("/specials/categories"),
  saveCategories: userApiMethods.post("/account/casts-favorites/setSpecials"),
  ...session.actions,
})(Index);
